import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';

class AuthCheck extends Component {
    componentWillMount() {
        this.getJobPath();
    }
    checkStatus() {
        if (localStorage.token) {
            return;
        }
        browserHistory.push('/login');
    }

    getJobPath = () => {
        const path = this.props.location.pathname;
        const search = this.props.location.search;

        if (!localStorage.token) {
            if (path && path.includes('/jobs/'))
                localStorage.setItem('job_path', path);
                localStorage.setItem('job_search', search);
        }
    };
    render() {
        this.checkStatus();
        return (
            <div className="Site-content authentication body-wrapper portal-content-wrapper">
                {localStorage.token && this.props.children}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    isLoggedin: state.authentication.isLoggedIn,
});

export default connect(
    mapStateToProps,
    null
)(AuthCheck);



// WEBPACK FOOTER //
// src/client/components/common/authentication/AuthCheck.js